export const __0__log__config__ = {
	DATE: false,
	TYPE: true,
}

export const isBrowser = typeof window !== 'undefined'